import * as React from "react";

const Exp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="49"
    fill="none"
    viewBox="0 0 49 49"
  >
    <rect width="49" height="49" fill="#fff" fillOpacity="0.03" rx="15"></rect>
    <rect
      width="48"
      height="48"
      x="0.5"
      y="0.5"
      stroke="#D1D9E2"
      strokeOpacity="0.3"
      rx="14.5"
    ></rect>
    <path
      stroke="#fff"
      d="M31.415 15.836v2.75A6.417 6.417 0 0 1 25 25.003m-6.417-9.167v2.75a6.417 6.417 0 0 0 6.417 6.417m0 0a6.417 6.417 0 0 1 6.416 6.416v2.75M25 25.003a6.417 6.417 0 0 0-6.417 6.416v2.75"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      d="M17.668 15.836h14.667m0 18.333H17.668"
    ></path>
  </svg>
);

export default Exp;
